import React from "react";
import { BottomSheet } from "react-spring-bottom-sheet";
import { Search, MapPin } from "react-feather";
import { Input } from "reactstrap";
// <link rel="stylesheet" href="https://unpkg.com/react-spring-bottom-sheet/dist/style.css" crossorigin="anonymous">
import "react-spring-bottom-sheet/dist/style.css";

export default class Test extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      bottomSheet: false,
      onDismiss: false,
    };
  }
  onDismiss() {
    this.setState({ bottomSheet: false });

    // setOpen(false);
  }
  toggleBottomSheet() {
    let obj = this.state.bottomSheet
      ? { bottomSheet: false }
      : { bottomSheet: true };
    this.setState(obj);
  }

  render() {
    return (
      <div>
        <BottomSheet
          defaultSnap={({ snapPoints, lastSnap }) =>
            lastSnap ?? Math.min(...snapPoints)
          }
          snapPoints={({ maxHeight }) => [
            maxHeight - maxHeight / 5,
            maxHeight * 0.6,
          ]}
          onDismiss={() => this.onDismiss()}
          open={this.state.bottomSheet}
        >
          {" "}
          <card className="rounded-12px drop-shadow20px block p-6 ">
            <div className="flex justify-between">
              <h1 className="fsize18 text262626 font-semibold">Filters</h1>
              <p className="fsize16 textE77817 underline  ">Clear all</p>
            </div>

            <div className="relative  mt-6 mb-8">
              <Search
                width="18"
                height="18"
                className="absolute filter-searchicon"
              />
              <Input
                type="text"
                name="search"
                className="w-full cust-shadow-md py-3 pl-12 pr-4 text#4B4B4B opacity-60per fsize14 rounded-full "
                placeholder="Search..."
                value={this.state.search}
                onChange={(e) => {
                  this.setState({ search: e.target.value });
                }}
              />
            </div>

            <div className="mb-6">
              <h1 className="fsize16 text262626 font-semibold">Domain</h1>
              <div className="mt-4">
                <div className="flex justify-between mb-1">
                  <div className="flex items-center ">
                    {/* <input type="checkbox" className="w-18px h-18px " /> */}
                    <label class="custcheckbox">
                      <p className="text262626 fsize14 opacity-80per ml-2">
                        Campus Selection
                      </p>
                      <input type="checkbox" checked />
                      <span class="overhide-span"></span>
                    </label>
                  </div>
                  <p className="text262626 fsize14 opacity-80per ml-2">16</p>
                </div>
                <div className="flex justify-between">
                  <div className="flex items-center ">
                    {/* <input type="checkbox" className="w-18px h-18px " /> */}
                    <label class="custcheckbox">
                      <p className="text262626 fsize14 opacity-80per ml-2">
                        Human Resource
                      </p>
                      <input type="checkbox" checked />
                      <span class="overhide-span"></span>
                    </label>
                  </div>
                  <p className="text262626 fsize14 opacity-80per ml-2">8</p>
                </div>
              </div>
            </div>

            {/* category */}
            <div className="mb-6">
              <h1 className="fsize16 text262626 font-semibold">Category</h1>
              <div className="mt-4">
                <div className="flex justify-between mb-1">
                  <div className="flex items-center ">
                    {/* <input type="checkbox" className="w-18px h-18px " /> */}
                    <label class="custcheckbox">
                      <p className="text262626 fsize14 opacity-80per ml-2">
                        0-2
                      </p>
                      <input type="checkbox" checked />
                      <span class="overhide-span"></span>
                    </label>
                  </div>
                  <p className="text262626 fsize14 opacity-80per ml-2">16</p>
                </div>
                <div className="flex justify-between">
                  <div className="flex items-center ">
                    {/* <input type="checkbox" className="w-18px h-18px " /> */}
                    <label class="custcheckbox">
                      <p className="text262626 fsize14 opacity-80per ml-2">
                        2-5
                      </p>
                      <input type="checkbox" checked />
                      <span class="overhide-span"></span>
                    </label>
                  </div>
                  <p className="text262626 fsize14 opacity-80per ml-2">8</p>
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center ">
                    {/* <input type="checkbox" className="w-18px h-18px " /> */}
                    <label class="custcheckbox">
                      <p className="text262626 fsize14 opacity-80per ml-2">
                        5-7
                      </p>
                      <input type="checkbox" />
                      <span class="overhide-span"></span>
                    </label>
                  </div>
                  <p className="text262626 fsize14 opacity-80per ml-2">0</p>
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center ">
                    {/* <input type="checkbox" className="w-18px h-18px " /> */}
                    <label class="custcheckbox">
                      <p className="text262626 fsize14 opacity-80per ml-2">
                        7-10
                      </p>
                      <input type="checkbox" />
                      <span class="overhide-span"></span>
                    </label>
                  </div>
                  <p className="text262626 fsize14 opacity-80per ml-2">5</p>
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center ">
                    {/* <input type="checkbox" className="w-18px h-18px " /> */}
                    <label class="custcheckbox">
                      <p className="text262626 fsize14 opacity-80per ml-2">
                        10+
                      </p>
                      <input type="checkbox" />
                      <span class="overhide-span"></span>
                    </label>
                  </div>
                  <p className="text262626 fsize14 opacity-80per ml-2">2</p>
                </div>
              </div>
            </div>

            {/* type */}
            <div className="mb-6">
              <h1 className="fsize16 text262626 font-semibold">Type</h1>
              <div className="mt-4">
                <div className="flex justify-between mb-1">
                  <div className="flex items-center ">
                    {/* <input type="checkbox" className="w-18px h-18px " /> */}
                    <label class="custcheckbox">
                      <p className="text262626 fsize14 opacity-80per ml-2">
                        Jobs
                      </p>
                      <input type="checkbox" checked />
                      <span class="overhide-span"></span>
                    </label>
                  </div>
                  <p className="text262626 fsize14 opacity-80per ml-2">16</p>
                </div>
                <div className="flex justify-between">
                  <div className="flex items-center ">
                    {/* <input type="checkbox" className="w-18px h-18px " /> */}
                    <label class="custcheckbox">
                      <p className="text262626 fsize14 opacity-80per ml-2">
                        Event
                      </p>
                      <input type="checkbox" checked />
                      <span class="overhide-span"></span>
                    </label>
                  </div>
                  <p className="text262626 fsize14 opacity-80per ml-2">8</p>
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center ">
                    {/* <input type="checkbox" className="w-18px h-18px " /> */}
                    <label class="custcheckbox">
                      <p className="text262626 fsize14 opacity-80per ml-2">
                        Bank
                      </p>
                      <input type="checkbox" />
                      <span class="overhide-span"></span>
                    </label>
                  </div>
                  <p className="text262626 fsize14 opacity-80per ml-2">0</p>
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center ">
                    {/* <input type="checkbox" className="w-18px h-18px " /> */}
                    <label class="custcheckbox">
                      <p className="text262626 fsize14 opacity-80per ml-2">
                        General
                      </p>
                      <input type="checkbox" />
                      <span class="overhide-span"></span>
                    </label>
                  </div>
                  <p className="text262626 fsize14 opacity-80per ml-2">5</p>
                </div>

                <div className="flex justify-between">
                  <div className="flex items-center ">
                    {/* <input type="checkbox" className="w-18px h-18px " /> */}
                    <label class="custcheckbox">
                      <p className="text262626 fsize14 opacity-80per ml-2">
                        Others
                      </p>
                      <input type="checkbox" />
                      <span class="overhide-span"></span>
                    </label>
                  </div>
                  <p className="text262626 fsize14 opacity-80per ml-2">2</p>
                </div>
              </div>
            </div>
          </card>
        </BottomSheet>
      </div>
    );
  }
}
